import BaseViewController from "./base-view-controller";
import mapDetailProviderData from "../utils/provider-detail-builder";

class CareTeamProfileDetailController extends BaseViewController {
  preprocessScreenData() {
    const mappedFields = mapDetailProviderData(
      this.appData.careTeamProviderDetailFieldsData,
      this.appData.providerDetailData
    );

    this.screen = {
      ...this.screen,
      fields: [...mappedFields]
    };
  }
}

export default CareTeamProfileDetailController;
